// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"b_linkButton__1ObqK"};